import React from 'react';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@fluentui/react-components';
import { AdminHeader } from '../components/layout/AdminHeader';
import { NavigationSidebar } from '../components/layout/NavigationSidebar';
import { SkipNavigation } from '../components/common';

const useStyles = makeStyles({
  layout: {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#fafafa',
  },
  contentWrapper: {
    marginLeft: '220px', // Sidebar width
    marginTop: '48px', // Header height
    width: 'calc(100% - 220px)',
    height: 'calc(100vh - 48px)',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  mainContent: {
    padding: '24px',
    maxWidth: '1440px', // M365 max content width
    margin: '0 auto',
  },
});

const MainAppLayout: React.FC = () => {
  const styles = useStyles();

  return (
    <div className={styles.layout}>
      {/* Skip Navigation for Accessibility */}
      <SkipNavigation />

      {/* M365 Teal Header */}
      <AdminHeader />

      {/* M365 Left Navigation Sidebar */}
      <NavigationSidebar />

      {/* Main Content Area */}
      <div className={styles.contentWrapper}>
        <main
          id="main-content"
          className={styles.mainContent}
          role="main"
          aria-label="Main content"
          tabIndex={-1}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MainAppLayout;
